import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { FatLiberation } from './pages/FatLiberation';
import { LearningGrowth } from './pages/LearningGrowth';
import { Publication } from './pages/Publication';
import { About } from './pages/About';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { FoundersQA } from './pages/blog/FoundersQA';
import { BlogCatalogue } from './pages/blog/BlogCatalogue';
import { Policies } from './pages/Policies';
import { AccessibilityPolicy } from './pages/AccessibilityPolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { ComingSoon } from './pages/ComingSoon';
// Cluster pages
import { SystemsPower } from './pages/clusters/SystemsPower';
import { Commitments } from './pages/clusters/Commitments';
import { Terminology } from './pages/clusters/Terminology';
import { FatFrameworks } from './pages/clusters/FatFrameworks';
import { Courses } from './pages/clusters/Courses';
import { WaysToLearn } from './pages/clusters/WaysToLearn';
import { AboutPublication } from './pages/clusters/AboutPublication';
import { Contribute } from './pages/clusters/Contribute';
import { ReadWaestm } from './pages/clusters/ReadWaestm';
import { WhoWeAre } from './pages/clusters/WhoWeAre';
import { HowWeWork } from './pages/clusters/HowWeWork';
import { CoProduction } from './pages/clusters/CoProduction';
import { Contributors } from './pages/clusters/Contributors';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        {/* Standalone Coming Soon Page */}
        <Route path="/coming-soon" element={<ComingSoon data-id="element-4" />} data-id="element-3" />

        {/* Main Site Routes with Layout */}
        <Route path="*" element={<div className="flex flex-col min-h-screen font-sans text-brand-black bg-brand-cream" data-id="element-6">
              <Navigation data-id="element-7" />
              <main className="flex-grow pt-16" data-id="element-8">
                <Routes data-id="element-9">
                  <Route path="/" element={<Home data-id="element-11" />} data-id="element-10" />
                  <Route path="/fat-liberation" element={<FatLiberation data-id="element-13" />} data-id="element-12" />
                  <Route path="/learning-growth" element={<LearningGrowth data-id="element-15" />} data-id="element-14" />
                  <Route path="/publication" element={<Publication data-id="element-17" />} data-id="element-16" />
                  <Route path="/about" element={<About data-id="element-19" />} data-id="element-18" />
                  <Route path="/blog" element={<Blog data-id="element-21" />} data-id="element-20" />
                  <Route path="/blog/catalogue" element={<BlogCatalogue data-id="element-23" />} data-id="element-22" />
                  <Route path="/blog/why-we-built-regrowth" element={<FoundersQA data-id="element-25" />} data-id="element-24" />
                  <Route path="/blog/:slug" element={<BlogPost data-id="element-27" />} data-id="element-26" />
                  <Route path="/policies" element={<Policies data-id="element-29" />} data-id="element-28" />
                  <Route path="/policies/accessibility" element={<AccessibilityPolicy data-id="element-31" />} data-id="element-30" />
                  <Route path="/policies/privacy" element={<PrivacyPolicy data-id="element-33" />} data-id="element-32" />
                  <Route path="/contact" element={<Contact data-id="element-35" />} data-id="element-34" />
                  <Route path="/faq" element={<FAQ data-id="element-37" />} data-id="element-36" />

                  {/* Cluster pages */}
                  <Route path="/clusters/systems-power" element={<SystemsPower data-id="element-39" />} data-id="element-38" />
                  <Route path="/clusters/commitments" element={<Commitments data-id="element-41" />} data-id="element-40" />
                  <Route path="/clusters/terminology" element={<Terminology data-id="element-43" />} data-id="element-42" />
                  <Route path="/clusters/fat-frameworks" element={<FatFrameworks data-id="element-45" />} data-id="element-44" />
                  <Route path="/clusters/courses" element={<Courses data-id="element-47" />} data-id="element-46" />
                  <Route path="/clusters/ways-to-learn" element={<WaysToLearn data-id="element-49" />} data-id="element-48" />
                  <Route path="/clusters/about-publication" element={<AboutPublication data-id="element-51" />} data-id="element-50" />
                  <Route path="/clusters/contribute" element={<Contribute data-id="element-53" />} data-id="element-52" />
                  <Route path="/clusters/read-waestm" element={<ReadWaestm data-id="element-55" />} data-id="element-54" />
                  <Route path="/clusters/who-we-are" element={<WhoWeAre data-id="element-57" />} data-id="element-56" />
                  <Route path="/clusters/how-we-work" element={<HowWeWork data-id="element-59" />} data-id="element-58" />
                  <Route path="/clusters/co-production" element={<CoProduction data-id="element-61" />} data-id="element-60" />
                  <Route path="/clusters/contributors" element={<Contributors data-id="element-63" />} data-id="element-62" />
                </Routes>
              </main>
              <Footer data-id="element-64" />
            </div>} data-id="element-5" />
      </Routes>
    </Router>;
}